module.exports = "<div>\r\n    Looks good\r\n    {{ (data | async)?.length }}\r\n</div>"